// extracted by mini-css-extract-plugin
export default {"navbar":"navigation_navbar__5vXm7","sticky":"navigation_sticky__P7a0k","logo_image":"navigation_logo_image__lrm85","link":"navigation_link__EkEK5"};